import { __ } from '@wordpress/i18n';
import {
        Popover, __experimentalHStack as HStack,__experimentalVStack as VStack,
        __experimentalText as Text, __experimentalToolsPanelItem as ToolsPanelItem , Button
} from '@wordpress/components';


const hovereffect_options = [
    { label: __('None', 'vayu-blocks'), value: 'none' },
    { label: __('Blur', 'vayu-blocks'), value: 'blur' },
    { label: __('Sepia', 'vayu-blocks'), value: 'sepia' },
    { label: __('GrayScale', 'vayu-blocks'), value: 'grayScale' },
    { label: __('GrayScale Reverse', 'vayu-blocks'), value: 'grayScalereverse' },
    { label: __('Zoom In', 'vayu-blocks'), value: 'zoom-in' },
    { label: __('Zoom Out', 'vayu-blocks'), value: 'zoom-out' },
    { label: __('Slide Up', 'vayu-blocks'), value: 'slide-up' },
    { label: __('Slide Down', 'vayu-blocks'), value: 'slide-down' },
    { label: __('Slide Left', 'vayu-blocks'), value: 'slide-left' },
    { label: __('Slide Right', 'vayu-blocks'), value: 'slide-right' },
    { label: __('Rotate', 'vayu-blocks'), value: 'rotate' },
];

export const Ihover = ({hovereffectPopoverAnchor,setishovereffectVisible,animationData,dataKey, onChange}) => {

    const handlehovereffectAnimationClick = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            hovereffect: {
                ...animationData.hovereffect,
                value: animation,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    


  return (
    
           <Popover
                placement="left-start"
                className='vayu_blocks_toolspanel_items_popover'
                anchor={hovereffectPopoverAnchor}
                onClose={() => setishovereffectVisible(false)}
                offset={35}
                resize
            >
                <VStack  style={{padding:'10px',
    width: '280px'}}
                >
                    <Text>
                    <span style={{fontWeight: '600'}}>{__('Hover Effect','vayu-blocks')}</span>
                    <p>{__('Select a hover effect for your element. These effects will only work when you hover over it.','vayu-blocks')}</p>
                    </Text>
                    <Text><HStack  spacing="2" wrap={true}>
                            {hovereffect_options.map((option) => (
                                option.value === 'none' ? (
                                    <Text 
                                        key={option.value}
                                        className={`vayu-blocks-ihover-main-panel vayu-blocks-ihover-main-panel-p4  ${!animationData?.hovereffect?.value || animationData?.hovereffect?.value === 'none' ? 'none-selected' : ''}
`}
                                        onClick={() => handlehovereffectAnimationClick('none')} // Update the animation value when clicked
                                        title="None"
                                    >

                                        <div className={`vayu-blocks-panel-ihover vayu-blocks-none-button   vayu_blocks_${option.value}`} >
                                       

                                        </div>
                                        <span className='vayu-blocks-ihover-new-panel-span'>
                                            {option.label}
                                        </span>

                                    </Text>
                                ) : (
                                    <Text
                                        key={option.value}
                                        className={`vayu-blocks-ihover-main-panel vayu-blocks-ihover-main-panel-p4  ${animationData?.hovereffect?.value === option.value ? 'selected' : ''}`}
                                        onClick={() => handlehovereffectAnimationClick(option.value)} // Update animation value on click
                                        title={option.label} // Title set dynamically
                                    >
                                        <div className={`vayu-blocks-panel-ihover vayu_blocks_${option.value}`} >  
                                            
                                        </div>
                                        <span className={`vayu-blocks-ihover-new-panel-span ${option.value === 'grayScalereverse' ? 'vayu_blocks_grayScalereverse-span' : ''}`}
                                        >
                                                {option.label}
                                            </span>
                                    </Text>
                                )
                            ))}
                        </HStack>
                        </Text>
                </VStack >
            </Popover>

  )
}

export const HoverEffectPanel = ({
	animationData,
	togglehovereffectVisible,
	ishovereffectVisible,
	sethovereffectPopoverAnchor,
    dataKey, onChange
}) => {

    const handlehovereffectAnimationClick = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            hovereffect: {
                ...animationData.hovereffect,
                value: animation,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    

    const selectedhovereffectEffect = hovereffect_options.find(opt => opt.value === animationData?.hovereffect?.value)?.label || '';

	return (
		<ToolsPanelItem
			className="vayu_blocks_animation_toolspanel_item"
			hasValue={() => !!animationData?.hovereffect?.value}
			label={__('Hover Effect', 'vayu-blocks')}
			onDeselect={() => handlehovereffectAnimationClick('none')}
			isShownByDefault
		>
			<Button
				ref={sethovereffectPopoverAnchor}
				onClick={togglehovereffectVisible}
				className={`block-editor-panel-animation-settings__dropdown ${ishovereffectVisible ? 'is-open' : ''}`}
			>
				<HStack alignment="left">
					{!animationData?.hovereffect?.value || animationData?.hovereffect?.value === 'none' ? (
						<div className={`vayu-blocks-panel-ihover vayu-blocks-none-button toolaspanel-size-none-button vayu_blocks_none`} ></div>
					) : (
						<div className={`vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color  vayu_blocks_${animationData?.hovereffect?.value}`} />
					)}
					<Text>
						{__(!animationData?.hovereffect?.value || animationData?.hovereffect?.value === 'none' ? 'Hover' : selectedhovereffectEffect)}
					</Text>
				</HStack>
			</Button>
		</ToolsPanelItem>
	);
};